// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
import {Autoplay} from 'swiper/modules';

export function curatedCardsSwiper() {
    const carousels = document.querySelectorAll('.curated-cards-carousel');

    function updateButtonColor(carousel, selector, color) {
        const buttons = carousel.querySelectorAll(selector);
        if (buttons) {
            buttons.forEach((button) => {
                button.style.fill = color;
            });
        }
    }

    function setButtonDisabled(carousel, selector, setDisabled) {
        const buttons = carousel.querySelectorAll(selector);
        if (buttons) {
            buttons.forEach((button) => {
                if (setDisabled) {
                    button.setAttribute('disabled', '');
                } else {
                    button.removeAttribute('disabled');
                }
            });
        }
    }

    // Loop through each carousel and initialize Swiper
    carousels.forEach((carousel) => {
        const carouselWrapper = carousel.querySelector('.swiper.cards-carousel');
        const isAutoplayEnabled = carousel.classList.contains('autoplay-enabled');
        const slidesCount = carousel.querySelectorAll('.swiper-slide').length;
        const slides = carousel.querySelectorAll('.swiper-slide');

        if (slidesCount >= 2) {
            // Define base modules (like Navigation, Pagination)
            let swiperModules = [];

            // Conditionally add Autoplay if the class exists
            if (isAutoplayEnabled) {
                swiperModules.push(Autoplay);
            }

            const swiper = new Swiper(carouselWrapper, {
                modules: swiperModules,
                autoplay: isAutoplayEnabled
                    ? {
                          delay: 5000,
                      }
                    : false,
                slidesPerView: 1.1,
                slidesPerGroup: 1,
                direction: 'horizontal',
                loop: false,
                a11y: {
                    slideRole: '',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1.1,
                        spaceBetween: 16,
                        preventInteractionOnTransition: true,
                    },
                    1200: {
                        slidesPerView: 1.1,
                        spaceBetween: 20,
                    },
                    1500: {
                        spaceBetween: 24,
                    },
                    1921: {
                        spaceBetween: 40,
                    },
                    2560: {
                        // WQXGA / UWFHD / QHD
                        slidesPerView: 1.1,
                        spaceBetween: 40,
                    },
                    2880: {
                        // WQXGA+
                        slidesPerView: 1.18,
                        spaceBetween: 40,
                    },
                    3440: {
                        // UWQHD
                        slidesPerView: 1.24,
                        spaceBetween: 40,
                    },
                },
                on: {
                    slideChange: function () {
                        const isFirstSlide = swiper.activeIndex === 0 && !swiper.params.loop;
                        const isLastSlide = swiper.activeIndex === swiper.slides.length - 1 && !swiper.params.loop;

                        updateButtonColor(carousel, '.swiper-button-prev svg path', isFirstSlide ? '#b9bdc8' : '#060D32');
                        updateButtonColor(carousel, '.swiper-button-next svg path', isLastSlide ? '#b9bdc8' : '#060D32');

                        if (isFirstSlide) {
                            setButtonDisabled(carousel, '.swiper-button-prev', true);
                        } else {
                            setButtonDisabled(carousel, '.swiper-button-prev', false);
                        }

                        if (isLastSlide) {
                            setButtonDisabled(carousel, '.swiper-button-next', true);
                        } else {
                            setButtonDisabled(carousel, '.swiper-button-next', false);
                        }
                    },
                },
            });

            const swiperPrev = carousel.querySelectorAll('.swiper-button-prev');
            const swiperNext = carousel.querySelectorAll('.swiper-button-next');

            const prevButtonPaths = carousel.querySelectorAll('.swiper-button-prev svg path');
            const color = swiper.activeIndex === 0 && !swiper.params.loop ? '#b9bdc8' : '#060D32';

            prevButtonPaths.forEach((path) => {
                path.style.fill = color;
            });

            swiperPrev.forEach((prev) => {
                prev.addEventListener('mousedown', () => {
                    swiper.slidePrev();
                });
                prev.addEventListener('touch', () => {
                    swiper.slidePrev();
                });
                prev.addEventListener('keydown', (e) => {
                    if (e.code == 'Space' || e.code == 'Enter') {
                        e.preventDefault();
                        swiper.slidePrev();
                        // Focus on current slide
                        slides[swiper.activeIndex].querySelector('a').focus();
                    }
                });
            });

            swiperNext.forEach((next) => {
                next.addEventListener('mousedown', () => {
                    swiper.slideNext();
                });
                next.addEventListener('touch', () => {
                    swiper.slideNext();
                });
                next.addEventListener('keydown', (e) => {
                    if (e.code == 'Space' || e.code == 'Enter') {
                        e.preventDefault();
                        swiper.slideNext();
                        // Focus on current slide
                        slides[swiper.activeIndex].querySelector('a').focus();
                    }
                });
            });

            setButtonDisabled(carousel, '.swiper-button-prev', true);
        } else {
            const swiperPrev = carousel.querySelectorAll('.swiper-button-prev');
            const swiperNext = carousel.querySelectorAll('.swiper-button-next');

            swiperPrev.forEach((prev) => {
                prev.style.display = 'none';
            });

            swiperNext.forEach((next) => {
                next.style.display = 'none';
            });

            carouselWrapper.style.margin = '0 0 0 0';
            carouselWrapper.style.width = '100%';
            carouselWrapper.style.maxWidth = '1520px';
        }
    });
}
